import React from 'react';

import { useParams } from 'react-router';
import { Link } from '~/lib/react-router-dom';

import { Box, Tab, Tabs } from '@mui/material';

import CustomLincPage from './CustomLincPage';
import MusementPage from './MusementPage';

const PROVIDER_TABS = [
  { key: 'musement', label: 'Musement', component: MusementPage, defaultSlug: 'musement-bookings' },
  { key: 'customlinc', label: 'CustomLinc', component: CustomLincPage, defaultSlug: 'customlinc-bookings' },
];

export default function ExperiencesTabContainer() {
  const { report } = useParams<{ report?: string }>();
  const providerKey = PROVIDER_TABS.find((t) => report?.startsWith(t.key))?.key ?? PROVIDER_TABS[0].key;
  const currentProvider = PROVIDER_TABS.find((t) => t.key === providerKey);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={providerKey}>
          {PROVIDER_TABS.map((tab) => (
            <Tab
              key={tab.key}
              value={tab.key}
              label={tab.label}
              component={Link}
              to={`/finance/experiences/${tab.defaultSlug}`}
              sx={{ textTransform: 'none' }}
            />
          ))}
        </Tabs>
      </Box>

      <Box component={currentProvider.component} />
    </Box>
  );
}
